<mat-card appearance="outlined" id="forgot-pwd-card">
  <mat-toolbar> <span>Forgot Password</span> </mat-toolbar>
  <mat-card-content>
    <div id="forgot-pwd-container">
      @if (formFlag) {
        <p>
          Please enter your email address below. After you submit it, an
          email will be sent to you with directions on how to reset your
          password.
        </p>
      }
      @if (!formFlag) {
        <p>
          Check your email and follow the password reset link in the email
          to reset your password. The reset link will only be valid for 24
          hours.
        </p>
      }
      @if (formFlag) {
        <form
          novalidate
          id="forgot-pwd-form"
          (ngSubmit)="submit()"
          >
          <mat-form-field>
            <input
              id="forgot-pwd-email"
              matInput
              placeholder="Email"
              [formControl]="emailControl"
              required
              (keyup)="removeWhitespace($event)"
              />
            @if (validate('required')) {
              <mat-error>
                Email is required
              </mat-error>
            }
            @if (validate('email') && !validate('required')) {
              <mat-error
                >
                Value must be a valid email
              </mat-error>
            }
          </mat-form-field>
          <div
            id="form-buttons"
            fxLayout="row"
            fxLayoutWrap
            fxLayoutAlign="end"
            >
            <button
              id="form-back-button"
              class="back-button support-buttons"
              mat-raised-button
              (click)="goBack()"
              type="button"
              color="secondary"
              >
              Back
            </button>
            <button
              id="submit-button"
              class="support-buttons"
              mat-raised-button
              color="primary"
              type="submit"
                        [disabled]="
                            emailControl.untouched || !emailControl.valid
                        "
              >
              Reset Password
            </button>
          </div>
        </form>
      }
      @if (!formFlag) {
        <div id="status-container">
          @if (sendingFlag) {
            <mat-progress-spinner
              mode="indeterminate"
              color="primary"
              >
            </mat-progress-spinner>
          }
          @if (!sendingFlag && !errors) {
            <p>
              Your password reset request has been sent.
            </p>
          }
          @if (!sendingFlag && errors) {
            <p>
              Passport is experiencing technical difficulties, please try
              again in 5 minutes.
            </p>
          }
        </div>
      }
    </div>
  </mat-card-content>
  @if (!formFlag) {
    <mat-card-actions>
      @if (!sendingFlag) {
        <button
          id="status-back-button"
          class="back-button"
          fxFill
          mat-raised-button
          (click)="goBack()"
          color="primary"
          type="button"
          >
          Back
        </button>
      }
    </mat-card-actions>
  }
</mat-card>
